export const invisibleWhitespaceRegex = /\p{Zs}/gu;

// Charcodes:
// [32, 160, 5760, 8192, 8194, 8196, 8198, 8200, 8202, 8239, 8287, 12288];
